import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import Bugsnag from '@bugsnag/js';
import { environment } from './environments/environment';
import { consumeCarHandoff } from './app/services/platform/car-handoff-storage';

Bugsnag.start({ apiKey: environment.BUGSNAG_API_KEY });

// Before the injector exists: the car's snapshot has to be the persisted state by the time any
// service reads it, and service construction order is not something to depend on.
consumeCarHandoff();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
